import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Financials_PaymentV3_TransactionRequestModelV3,
  ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel,
  ResponseModels_Financials_PaymentV3_TransactionStatusV3ResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetPaymentTransactionStatusV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  paymentId: string;
};
/**
 * Returns a status object for a certain payment for iDeal 2.0
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionStatusV3ResponseModel Success
 */
export function getPaymentTransactionStatusV3(
  { businessUnit, label, customerId, accountId, paymentId }: GetPaymentTransactionStatusV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionStatusV3ResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/v3/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/financials/payments/${paymentId}`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type CreatePaymentTransactionForInvoiceV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  invoiceId: number;
  requestBody: RequestModels_Financials_PaymentV3_TransactionRequestModelV3;
};
/**
 * Creates an iDeal 2.0 payment for a certain invoice.
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel Success
 */
export function createPaymentTransactionForInvoiceV3(
  { businessUnit, label, customerId, accountId, invoiceId, requestBody }: CreatePaymentTransactionForInvoiceV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/v3/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/financials/payments/invoices/${invoiceId}`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type CreatePaymentTransactionForPaymentArrangementV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  requestBody: RequestModels_Financials_PaymentV3_TransactionRequestModelV3;
};
/**
 * Creates an iDeal 2.0 payment for a payment arrangement
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel Success
 */
export function createPaymentTransactionForPaymentArrangementV3(
  { businessUnit, label, customerId, accountId, requestBody }: CreatePaymentTransactionForPaymentArrangementV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/v3/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/financials/payments/paymentarrangement`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}

type CreatePaymentTransactionForFreeDepositV3 = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
  requestBody: RequestModels_Financials_PaymentV3_TransactionRequestModelV3;
};
/**
 * Creates an iDeal 2.0 payment for a free deposit
 *
 * @returns ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel Success
 */
export function createPaymentTransactionForFreeDepositV3(
  { businessUnit, label, customerId, accountId, requestBody }: CreatePaymentTransactionForFreeDepositV3,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Financials_PaymentV3_TransactionResponseV3ResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/v3/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/financials/payments/deposit`,
      body: requestBody,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
